/** Escape HTML special characters to prevent XSS in rendered markup. Null/undefined render as ''. */
export function escapeHtml(str) {
    return (str ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
/** Escape a string for safe use inside an HTML attribute value. */
export function escapeAttr(str) {
    return escapeHtml(str);
}
